import {
	Attachment,
	AttachmentInfo,
	AttachmentPreview,
	AttachmentRemove,
	Attachments,
} from "./ai-elements/attachments";
import type { AttachmentFile } from "./ai-elements/prompt-input";
import { usePromptInputAttachments } from "./ai-elements/prompt-input";
import { DrawerPdfViewer } from "./pdf-viewer/drawer-pdf-viewer";

function isPdf(attachment: AttachmentFile) {
	return attachment.mediaType === "application/pdf";
}

function PromptInputAttachmentsDisplay() {
	const attachments = usePromptInputAttachments();

	if (attachments.files.length === 0) {
		return null;
	}

	return (
		<Attachments variant="inline">
			{attachments.files.map((attachment) =>
				isPdf(attachment) ? (
					<DrawerPdfViewer
						key={attachment.id}
						url={attachment.url}
						filename={attachment.filename || "Document.pdf"}
					>
						<Attachment
							data={attachment}
							onRemove={() => attachments.remove(attachment.id)}
						>
							<AttachmentPreview />
							<AttachmentInfo className="max-w-20" />
							<AttachmentRemove />
						</Attachment>
					</DrawerPdfViewer>
				) : (
					<Attachment
						data={attachment}
						key={attachment.id}
						onRemove={() => attachments.remove(attachment.id)}
					>
						<AttachmentPreview />
						<AttachmentInfo className="max-w-20" />
						<AttachmentRemove />
					</Attachment>
				),
			)}
		</Attachments>
	);
}

export { PromptInputAttachmentsDisplay };
